// extracted by mini-css-extract-plugin
export default {"logo":"NavBar_logo__oy8lx","logo_placeholder":"NavBar_logo_placeholder__Mq73j"};